module.exports = __webpack_public_path__ + "img/cup.ad1415cf.svg";